webpackJsonp([2,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(53);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(124);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _store = __webpack_require__(59);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  store: _store2.default,
	  components: { App: _App2.default }
	});

/***/ },

/***/ 58:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(65);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(69);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(70);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(72);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(71);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _events = __webpack_require__(22);
	
	var _crypto = __webpack_require__(134);
	
	var _crypto2 = _interopRequireDefault(_crypto);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MAX = 1000;
	var MIN = 5000;
	
	var randomInterval = function randomInterval() {
	  var diff = MAX - MIN;
	  var multiplier = diff + 1;
	  var unshifted = Math.random() * multiplier;
	  return Math.floor(unshifted) + MIN;
	};
	
	var Api = function (_EventEmitter) {
	  (0, _inherits3.default)(Api, _EventEmitter);
	
	  function Api() {
	    (0, _classCallCheck3.default)(this, Api);
	    return (0, _possibleConstructorReturn3.default)(this, (Api.__proto__ || (0, _getPrototypeOf2.default)(Api)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Api, [{
	    key: 'connect',
	    value: function connect() {
	      this.fakeSse();
	    }
	  }, {
	    key: 'fakeSse',
	    value: function fakeSse() {
	      var _this2 = this;
	
	      setInterval(function () {
	        _this2.onEvent(_crypto2.default.randomBytes(32).toString('hex'));
	      }, randomInterval());
	    }
	  }, {
	    key: 'onEvent',
	    value: function onEvent(event) {
	      this.emit('event', event);
	    }
	  }]);
	  return Api;
	}(_events.EventEmitter);
	
	exports.default = Api;

/***/ },

/***/ 59:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.options = undefined;
	
	var _vue = __webpack_require__(53);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(130);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _http = __webpack_require__(110);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _api = __webpack_require__(58);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var options = {
	  state: {
	    value: 'foobar',
	    items: []
	  },
	  mutations: {
	    SET_VALUE: function SET_VALUE(state, value) {
	      state.value = value;
	    },
	    ADD_ITEM: function ADD_ITEM(state, item) {
	      if (state.items.length === 10) {
	        state.items.shift();
	      }
	      state.items.push(item);
	    }
	  },
	  actions: {
	    REVERSE: function REVERSE(_ref, _ref2) {
	      var commit = _ref.commit;
	      var value = _ref2.value;
	
	      var reversed = value.split('').reverse().join('');
	      return _http2.default.get('https://httpbin.org/get?param=' + reversed, function (response) {
	        var body = '';
	        response.on('data', function (chunk) {
	          body += chunk;
	        });
	        response.on('end', function () {
	          var obj = JSON.parse(body);
	          commit('SET_VALUE', obj.args.param);
	        });
	      });
	    },
	    CONNECT: function CONNECT(_ref3) {
	      var commit = _ref3.commit;
	
	      var api = new _api2.default();
	      api.on('event', function (event) {
	        commit('ADD_ITEM', event);
	      });
	      api.connect();
	    }
	  }
	};
	
	exports.default = new _vuex2.default.Store(options);
	exports.options = options;

/***/ },

/***/ 60:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Reverse = __webpack_require__(126);
	
	var _Reverse2 = _interopRequireDefault(_Reverse);
	
	var _List = __webpack_require__(125);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    Reverse: _Reverse2.default,
	    List: _List2.default
	  }
	};

/***/ },

/***/ 61:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'list',
	  computed: {
	    items: function items() {
	      return this.$store.state.items;
	    }
	  },
	  created: function created() {
	    this.$store.dispatch('CONNECT');
	  }
	};

/***/ },

/***/ 62:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'reverse',
	  computed: {
	    value: function value() {
	      return this.$store.state.value;
	    }
	  },
	  methods: {
	    reverseValue: function reverseValue() {
	      this.$store.dispatch('REVERSE', { value: this.$store.state.value });
	    }
	  }
	};

/***/ },

/***/ 109:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 124:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(109)
	
	/* script */
	__vue_exports__ = __webpack_require__(60)
	
	/* template */
	var __vue_template__ = __webpack_require__(129)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 125:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(61)
	
	/* template */
	var __vue_template__ = __webpack_require__(128)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 126:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(62)
	
	/* template */
	var __vue_template__ = __webpack_require__(127)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 127:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;
	  return _vm._h('div', [_vm._h('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        _vm.reverseValue()
	      }
	    }
	  }, [_vm._s(_vm.value)])])
	},staticRenderFns: []}

/***/ },

/***/ 128:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;
	  return _vm._h('ul', [_vm._l((_vm.items), function(item) {
	    return _vm._h('li', ["\n    " + _vm._s(item) + "\n  "])
	  })])
	},staticRenderFns: []}

/***/ },

/***/ 129:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;
	  return _vm._h('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_vm._h('reverse'), " ", _vm._h('list')])
	},staticRenderFns: []}

/***/ },

/***/ 150:
/***/ function(module, exports) {

	/* (ignored) */

/***/ },

/***/ 151:
/***/ function(module, exports) {

	/* (ignored) */

/***/ }

});


// WEBPACK FOOTER //
// static/js/app.58f7fcaf8ec6d27cdb8d.js